import React from "react";
import Parser from "../../parser";
import { Context } from "../../context";
/*
 * if (selector(domNode, "div", "wp-block-cover")
        && (typeof domNode.attribs.style !== "undefined")) {
        if (domNode.children && domNode.children.length >= 2) {
          try {
            const span = domNode.children[0];
            domNode.children[1].children.unshift(Object.assign({}, span));
            domNode.children = domNode.children.slice(1);
          } catch(e) {
              console.error(e); // eslint-disable-line
            return <></>;
          }
        }
        let backgroundImage = domNode.attribs.style.split("; ").find(e => {
          return e.split(":")[0] === "background-image";
        });
        try {
          backgroundImage = backgroundImage.split("url(")[1].slice(0,-1);
          const renderedBackgroundImage = getImgUrl(backgroundImage);
          domNode.attribs.style = domNode.attribs.style.replace(backgroundImage,
            (domNode.attribs.class.includes("featured") && props.coverImage)
              ? getSrc(props.coverImage.localFile)
              : renderedBackgroundImage);
        } catch(e) {
            console.error(e); // eslint-disable-line
        }
      }*/
const Cover = (props) => {
    const { allImages, featuredImage } = React.useContext(Context);
    const fallback = props.targetImage ||
        allImages.find((e) => parseInt(e.databaseId) === parseInt(props.attributes.id) ||
            parseInt(e.databaseId) === parseInt(props.attributes.mediaId));
    const imgUrl = (props.attributes.gcoFeaturedImage === true
        ? featuredImage?.node || fallback
        : fallback)?.localFile?.childImageSharp?.xxl.images.fallback.src ||
        props.attributes.url;
    const minHeight = props.attributes.minHeight
        ? props.attributes.minHeight + "px"
        : undefined;
    let classNameCustomParent = props.attributes.contentPosition ? " is-position-" + props.attributes?.contentPosition?.split(" ").join("-") : "";
    classNameCustomParent += (typeof props.attributes?.url !== "undefined") ? " has-image " : "";
    classNameCustomParent += typeof props.attributes.isDark === "undefined" ? " is-dark " : " is-light ";
    const bgColorChild = props.attributes?.overlayColor ? " has-" + props.attributes?.overlayColor + "-background-color " : "";
    const bgColorDimRatio = typeof props.attributes?.dimRatio === "number" ? " has-background-dim-" + props.attributes?.dimRatio + " " : "has-background-dim-100";
    return (React.createElement("div", { className: props.attributes.className + " " + classNameCustomParent + " has-parallax has-custom-content-position ", style: {
            backgroundImage: "url(" + imgUrl + ")",
            minHeight,
        } },
        React.createElement("div", { className: "wp-block-cover__inner-container" + bgColorChild },
            React.createElement("span", { "aria-hidden": "true", class: "wp-block-cover__background has-background-dim " + bgColorChild + " " + bgColorDimRatio }),
            React.createElement(Parser, { structure: props.innerBlocks }))));
};
export default Cover;
